import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
    currentVehicle: {}
}

export const getters = {}

export const mutations = {
    SET_EXCEPTIONS(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
    },
    SET_EXCEPTION(state, objects) {
        state.currentVehicle = objects
    }
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async getInstanceExceptionById({ commit }, { exceptionId } = {}) {
        try {
            return await graphqlClient.query({
                query: gql`
                  query getInstanceExceptionById($Id: ID!){
                    instanceExceptionById(id: $Id) {
                      id
                      status
                      description
                      collection_id
                      collection {
                        cost
                      }
                      photos {
                        id
                        url
                      }
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ Id: exceptionId }
            }).then((response) => {
              // // console.log(response)
              commit('SET_EXCEPTION', response.data.instanceExceptionById)
              return response.data.instanceExceptionById
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async getInstanceExceptionsByClientId({ commit }, { clientId } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query getInstanceExceptionsByClientId($Id: Int!){
                    instanceExceptionsByClientId(client_id: $Id) {
                      id
                      status
                      description
                      collection_id
                      collection {
                        cost
                      }
                      photos {
                        id
                        url
                      }
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ Id: clientId }
            })
            commit('SET_EXCEPTIONS', response.data.instanceExceptionsByClientId)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async getInstanceExceptionsByServiceId({ commit }, { serviceId } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query getInstanceExceptionsByServiceId($Id: Int!){
                    instanceExceptionsByServiceId(service_id: $Id) {
                      id
                      status
                      description
                      collection_id
                      collection {
                        cost
                      }
                      photos {
                        id
                        url
                      }
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ Id: serviceId }
            })
            commit('SET_EXCEPTIONS', response.data.instanceExceptionsByServiceId)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },
    async getInstanceExceptionsByStatus({ commit }, { status } = {}) {
        try {
            return await graphqlClient.query({
                query: gql`
                  query getInstanceExceptionsByStatus($Status: Int!){
                    instanceExceptionsByStatus(status: $Status) {
                      id
                      status
                      collection{
                        id,
                        expected_collection_time,
                        collection_date,
                        cost,
                        service_id,
                        client{
                          id
                          client_name
                        }
                        site{
                          id,
                          address,
                          suburb,
                          postcode,
                          phone,
                          mobile
                        }
                      }
                      description
                      photos {
                        id
                        url
                      }
                      created_at
                      deleted_at
                      updated_at
                    }
                  }
                `,
                variables:{ Status: status }
            }).then((response) => {
              commit('SET_EXCEPTIONS', response.data.instanceExceptionsByStatus)
              return response.data.instanceExceptionsByStatus
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createCollectionInstanceException({ commit }, {status, description, collectionId} = {}) {
        try {
            // let that = this
            await graphqlClient.mutate({
                mutation: gql`
                mutation CreateCollectionInstanceException($Status: Int $Description: String $Collection: Int)  {
                  createCollectionInstanceException(exception:{status:$Status description:$Description collection_id:$Collection}) {
                    id
                  }
                }
                `,
                variables: { Status: status, Description: description, Collection: collectionId },
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async updateCollectionInstanceException({ commit }, {exceptionId, status, collectionId} = {}) {
        try {
            return await graphqlClient.mutate({
                mutation: gql`
                mutation UpdateCollectionInstanceException($Id:Int! $Status: Int $Collection: Int)  {
                  updateCollectionInstanceException(id: $Id exception:{status:$Status collection_id:$Collection}) {
                    id
                  }
                }
                `,
                variables: { Id: exceptionId, Status: status, Collection: collectionId },
            }).then((res)=>{
              // // console.log(res)
              commit('SET_EXCEPTIONS', res.data.updateCollectionInstanceException)
              return res.data.updateCollectionInstanceException
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async deleteCollectionInstanceException({ commit }, {exceptionId} = {}) {
        try {
            // let that = this
            const response = await graphqlClient.mutate({
                mutation: gql`
                mutation DeleteCollectionInstanceException($Id:Int!)  {
                  deleteCollectionInstanceException(id: $vId) {
                    id
                  }
                }
                `,
                variables: { Id: exceptionId},
            })
            commit('SET_EXCEPTIONS', response.data.deleteVehicle)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    }
}
